import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Radio,
  BookOpen,
  Calendar,
  CreditCard,
  Users,
  Ban,
  Wallet,
  Settings,
  GraduationCap,
} from 'lucide-react';
import { cn } from '../../lib/cn';
import { hasRank, type AdminUser } from '../../hooks/useAuth';
import { useT } from '../../i18n';
import type { TKey } from '../../i18n/ru';

interface NavItem {
  to: string;
  labelKey: TKey;
  Icon: typeof LayoutDashboard;
  minRank?: number;
}

const NAV: NavItem[] = [
  { to: '/', labelKey: 'nav.dashboard', Icon: LayoutDashboard },
  { to: '/channels', labelKey: 'nav.channels', Icon: Radio, minRank: 10 },
  { to: '/courses', labelKey: 'nav.courses', Icon: BookOpen, minRank: 10 },
  { to: '/calendar', labelKey: 'nav.calendar', Icon: Calendar, minRank: 10 },
  { to: '/payments', labelKey: 'nav.payments', Icon: CreditCard, minRank: 10 },
  { to: '/users', labelKey: 'nav.users', Icon: Users, minRank: 10 },
  { to: '/kicks', labelKey: 'nav.kicks', Icon: Ban, minRank: 10 },
  { to: '/payment-methods', labelKey: 'nav.paymentMethods', Icon: Wallet, minRank: 20 },
  { to: '/settings', labelKey: 'nav.settings', Icon: Settings, minRank: 30 },
];

export function Sidebar({ user }: { user: AdminUser }) {
  const t = useT();
  return (
    <aside className="flex h-screen w-60 flex-col border-r border-slate-200 bg-white">
      <div className="flex items-center gap-2 border-b border-slate-200 p-4">
        <GraduationCap className="h-6 w-6 text-slate-900" />
        <span className="text-lg font-semibold text-slate-900">LMS Admin</span>
      </div>
      <nav className="flex-1 space-y-0.5 p-2">
        {NAV.filter((item) => !item.minRank || hasRank(user, item.minRank)).map(({ to, labelKey, Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive ? 'bg-slate-100 text-slate-900' : 'text-slate-600 hover:bg-slate-50',
              )
            }
          >
            <Icon className="h-4 w-4" />
            {t(labelKey)}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-slate-200 p-3 text-xs text-slate-500">
        <div>{user.role}</div>
        <div className="font-mono">{user.telegram_id}</div>
      </div>
    </aside>
  );
}
